import { tryParseDockerfile } from "../../shared/dockerfile";
import { volumeIsReadOnly } from "../../shared/volumes";

export function stepStorageVolumeName(dockerfileContent: string | undefined) {
  if (!dockerfileContent) return null;
  const volumes = tryParseDockerfile(dockerfileContent)
    .filter((i) => i.kind === "volume")
    .map((i) => i.volume);
  return (
    (volumes.find((v) => !volumeIsReadOnly(v)) ?? volumes[0])?.name ?? null
  );
}
